import React, {Component} from 'react';
import MapDialog from "./components/MapDialog";
import {NavLink, Route, Switch} from "react-router-dom";
import Activities from "./Activities";
import Transport from "./Transport";

import image_1 from "../../../resources/images/essaouira/location_image1.jpg";
import image_2 from "../../../resources/images/essaouira/location_image2.jpg";
import image_4 from "../../../resources/images/essaouira/location_image4.jpg";
import image_5 from "../../../resources/images/essaouira/location_image5.jpg";
import ImageList from "../../components/ImageList";

const images = [
    {
        img: image_2,
        title: "AA",
        author: "BB",
        cols: 2
    },
    {
        img: image_1,
        title: "AA",
        author: "BB",
        cols: 2,
    },
    {
        img: image_5,
        title: "AA",
        author: "BB",
        cols: 2
    },
    {
        img: image_4,
        title: "AA",
        author: "BB",
        cols: 2
    }
];

class Essaouira extends Component {

    state = {
        mapOpen: false,
        festOpen: false
    };

    handleOpen(toggleName) {
        this.setState({
            [toggleName]: true
        });
    }

    handleClose(toggleName) {
        this.setState({
            [toggleName]: false
        });
    }

    renderPage = () => {
        return (
            <React.Fragment>
                <MapDialog
                    open={this.state.mapOpen}
                    onClose={e => this.handleClose('mapOpen')}
                />
                <div className={"info-split-wrap"}>
                    <div className={"half_width left_half"}>
                        <p className={"info_text"}><strong>Essaouira</strong>, formerly known
                            as <strong>Mogador</strong>,
                            is an ancient port on the Atlantic coast, two hours west of <strong>Marrakech</strong>.
                        </p>
                        <p className={"info_text"}>In 2001, the medina of Essaouira was awarded world heritage status by
                            UNESCO. With its bustling fishing port, relaxed and friendly atmosphere, Essaouira is a town
                            which lives up to its name, Es-Saouira, &#8220;the beautifully designed&#8221;.
                        </p>
                        <p className={"info_text"}>Artists, writers, poets and painters are spellbound by the magic. The
                            unspoiled, serene atmosphere makes it seem like time stands still. Essaouira has many
                            treasures
                            simply waiting to be discovered in its narrow alleyways behind the walled medina. It is a
                            jewel
                            in the heart of Morocco.
                        </p>
                        <table className={"even_spaced_table"}>
                            <thead>
                            <tr>
                                <td>
                                    <h3 className={"page_link"} onClick={e => this.handleOpen('mapOpen')}>Map</h3>
                                </td>
                                <td>
                                    <NavLink className={"page_link"} to={"/essaouira/activities"}><h3>Festivals, Markets &
                                        Activities</h3></NavLink>
                                </td>
                                <td>
                                    <NavLink className={"page_link"} to={"/essaouira/transport"}><h3>Flights & Local Transport</h3></NavLink>
                                </td>
                            </tr>
                            </thead>
                        </table>
                    </div>
                    <div className={"half_width right_half"}>
                        <ImageList images={images}/>
                    </div>
                </div>

            </React.Fragment>
        );
    };

    render() {
        return (
            <React.Fragment>
                <Switch>
                    <Route path={"/essaouira"} exact={true} render={() => this.renderPage()}/>
                    <Route path={"/essaouira/activities"} render={() => <Activities/>}/>
                    <Route path={"/essaouira/transport"} render={() => <Transport/>}/>
                </Switch>
            </React.Fragment>
        );
    }
}

export default Essaouira